export const EVENTS = {
	DOCUMENT_UPDATE: "document:update"
};
